import { Link } from 'react-router-dom';
import { ClockIcon, MapIcon, MessageIcon, TelephoneIcon } from '../../components/Icon';

function InfoContact() {
  return (
    <div className='grid grid-cols-2 gap-5 font-medium text-sm p-1'>
      <div className='col-span-1 flex items-center'>
        <div className='mr-[10px] w-10 min-w-[40px] h-10 rounded-[50%] border-[1px] border-primary text-primary flex-center'>
          <MapIcon />
        </div>
        <div>
          <b className='block'>Địa chỉ:</b>
          <span>Yết Kiêu - Gia Lộc - TP Hải Dương</span>
        </div>
      </div>

      <div className='col-span-1 flex items-center'>
        <div className='mr-[10px] w-10 min-w-[40px] h-10 rounded-[50%] border-[1px] border-primary text-primary flex-center'>
          <ClockIcon />
        </div>
        <div>
          <b className='block'>Thời gian làm việc:</b>
          <span>
            6h - 22h <br></br>Từ thứ 2 đến chủ nhật
          </span>
        </div>
      </div>

      <div className='col-span-1 flex items-center'>
        <div className='mr-[10px] w-10 min-w-[40px] h-10 rounded-[50%] border-[1px] border-primary text-primary flex-center'>
          <TelephoneIcon />
        </div>
        <div>
          <b className='block'>Hotline:</b>
          <Link className='cursor-pointer hover:text-primary transition'>0584.564.666</Link>
        </div>
      </div>

      <div className='col-span-1 flex items-center'>
        <div className='mr-[10px] w-10 min-w-[40px] h-10 rounded-[50%] border-[1px] border-primary text-primary flex-center'>
          <MessageIcon />
        </div>
        <div>
          <b className='block'>Email:</b>
          <a
            href='https://mail.google.com/mail/u/0/#inbox'
            className='cursor-pointer hover:text-primary transition'>
            truongmt1112
            <span className='inline-block'>@gmai</span>
            <span className='inline-block'>.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default InfoContact;
